import { render, staticRenderFns } from "./manoobra.vue?vue&type=template&id=6d53022c"
import script from "./manoobra.vue?vue&type=script&lang=js"
export * from "./manoobra.vue?vue&type=script&lang=js"
import style0 from "./manoobra.vue?vue&type=style&index=0&id=6d53022c&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports